export default function() {
    const tokensFromURL = Odigeo.History.getFragment().split('/');
    const infoToken = tokensFromURL.pop();
    const crmToken = tokensFromURL.pop();

    let tokens = {infoToken, crmToken};
    const infoTokenSplit = infoToken.split('?');

    if (infoTokenSplit.length === 2) {
        const [infoToken, utmParameters] = infoTokenSplit;
        tokens = {...tokens, infoToken, utmParameters};
    }

    return tokens;
}
